<template>
  <div class="magazine">
    <div class="relative">
      <div class="relative flex items-center justify-between mb-8 md:mb-16">
        <div>
          <h4 class="module__title">{{ meta.title }}</h4>
          <div v-if="meta.description" class="module__description">{{ meta.description }}</div>
        </div>
        <div v-show="swiperButtonShow" class="hidden md:flex items-center justify-center" style="width: fit-content; gap: 8px">
          <div class="flex items-center justify-center" :class="`swiper-button-prev swiper-button-prev-${cid}`" slot="button-prev">
            <i class="owl-direction-left"></i>
          </div>
          <div class="flex items-center justify-center" :class="`swiper-button-next swiper-button-next-${cid}`" slot="button-next">
            <i class="owl-direction-right"></i>
          </div>
        </div>
      </div>
      <!-- <div class="flex flex-wrap"> -->
      <swiper :options="options" :ref="`swiper-magazine-${cid}`" class="h-full sm:rounded">
        <swiper-slide v-for="(col, index) in meta.content" :key="`meta-${index}`">
          <router-link :to="{name: 'Event', params: { eventId: col.id }}" class="no-underline" @click.native="gaEvent(col.id)" target="_blank">
            <div class="magazine__col__cover__wrap">
              <div class="magazine__col__cover" v-lazy:background-image="coverImage(col.image, index)"></div>
            </div>
            <div class="desp m-8">
              <h5 class="text-base font-bold text-grey-darker mb-4">{{ col.title }}</h5>
              <p class="text-sm tracking-wide leading-md text-grey-darker">{{ col.subject }}</p>
            </div>
          </router-link>
        </swiper-slide>
      </swiper>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'module_Magazine',
  props: ['meta'],
  data () {
    return {
      // swiper: null,
      cid: this._uid,
      options: {
        loop: false,
        preventInteractionOnTransition: true,
        slideToClickedSlide: false,
        navigation: {
          nextEl: `.swiper-button-next-${this._uid}`,
          prevEl: `.swiper-button-prev-${this._uid}`
        },
        breakpoints: {
          3000: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 24
          },
          800: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16
          },
          580: {
            slidesPerView: 1.5,
            slidesPerGroup: 1.5,
            spaceBetween: 16
          },
          430: {
            slidesPerView: 1.2,
            slidesPerGroup: 1.2,
            spaceBetween: 16
          }
        },
        pagination: {
          el: '.swiper-pagination'
        }
      },
      MAGNIFACATION: 1.5,
      swiperButtonShow: false
    }
  },
  computed: {
    ...mapGetters([
      'initWidth'
    ]),
    magazineImageWidth () {
      if (this.initWidth >= 1200) {
        return 381
      } else if (this.initWidth < 1200 && this.initWidth >= 992) {
        return 311
      } else if (this.initWidth < 992 && this.initWidth >= 801) {
        return 236
      } else if (this.initWidth < 801 && this.initWidth >= 768) {
        return 370
      } else if (this.initWidth < 768 && this.initWidth >= 581) {
        return 282
      } else {
        return 381
      }
    },
    swiper () {
      return this.$refs[`swiper-${this.cid}`].swiper
    }
  },
  methods: {
    coverImage: function (image, index) {
      return image ? `${image}?width=${this.magazineImageWidth * this.MAGNIFACATION}&lock=${index}&format=webp` : require('@/assets/images/default-event.jpg')
    },
    gaEvent (name) {
      window.dataLayer.push({
        event: `index_event`,
        key: name
      })
    }
  },
  mounted() {
    // console.log('swiper container width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.width)
    // console.log('all slides width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.virtualSize)
    this.$nextTick(() => {
      const swiperWidth = this.$refs[`swiper-magazine-${this.cid}`]?.swiper?.width
      const swiperSlideWidth = this.$refs[`swiper-magazine-${this.cid}`]?.swiper?.virtualSize
      if (swiperSlideWidth > swiperWidth) {
        this.swiperButtonShow = true
      } else {
        this.swiperButtonShow = false
      }
    })
  }
}
</script>

<style lang="sass" scoped>
.magazine
  @apply mb-0 py-16
  @screen md
    @apply mb-48 -mx-8 py-0
  // overflow: hidden
  &__col
    @apply p-8
    &__cover
      @apply w-full ease
      border-radius: 1.25rem
      padding-top: imageRatio(397, 260)
      background:
        position: center
        repeat: no-repeat
        size: cover
      transform: scale(1.005)
      &:hover
        transform: scale(1.05)
      &__wrap
        @apply overflow-hidden
        border-radius: 1.25rem
</style>
<style lang="sass">
.magazine
  .swiper-container
    @apply px-16
    @screen sm
      @apply px-0
  .swiper-button-prev, .swiper-button-next
    @apply outline-none #{!important} rounded-full bg-grey-lightest
    position: relative !important
    // padding-top: 4px
    // padding-left: 2px
    background-image: none !important
    width: 35px !important
    height: 35px !important
    margin-top: 0px !important
    // z-index: 8
    i[class*=owl-direction]
      @apply text-grey-darkest
      font-size: 18px
  .swiper-button-prev
    left: initial
  //   right: 0px !important
  //   @screen sm
  //     right: 17.5px !important
  .swiper-button-next
    right: initial
  //   right: 0px !important
  //   @screen sm
  //     right: -17.5px !important
  .swiper-button-disabled
    @apply cursor-not-allowed
</style>
